// src/ElectronicsInfo.js

import React, { useState } from 'react';
import './ElectronicsInfo.css';

const electronicsData = {
  "Current": {
    importance: "The flow of electric charge, measured in amperes (A).",
    symbol: "I",
    example: "A current of 5A flowing through a resistor."
  },
  "Voltage": {
    importance: "The electrical potential difference between two points, measured in volts (V).",
    symbol: "V",
    example: "A 9V battery powering a circuit."
  },
  "Resistance": {
    importance: "The opposition to the flow of current, measured in ohms (Ω).",
    symbol: "R",
    example: "A 100Ω resistor in a circuit."
  },
  "Capacitance": {
    importance: "The ability of a system to store charge, measured in farads (F).",
    symbol: "C",
    example: "A 10µF capacitor in a filter circuit."
  },
  "Inductance": {
    importance: "The property of a conductor by which a change in current induces a voltage, measured in henrys (H).",
    symbol: "L",
    example: "An inductor in a choke circuit."
  },
  "Transistor": {
    importance: "A semiconductor device used to amplify or switch electronic signals.",
    symbol: "Q",
    example: "An NPN transistor used in a switching circuit."
  },
  "Diode": {
    importance: "A component that allows current to flow in one direction only.",
    symbol: "D",
    example: "A diode in a rectifier circuit."
  },
  "Integrated Circuit": {
    importance: "A set of electronic circuits on a small chip of semiconductor material.",
    symbol: "IC",
    example: "A 555 timer IC used in a timer circuit."
  },
  "Oscillator": {
    importance: "A circuit that generates a continuous output waveform.",
    symbol: "OSC",
    example: "A crystal oscillator in a clock circuit."
  },
  "Sensor": {
    importance: "A device that detects and responds to some type of input from the physical environment.",
    symbol: "S",
    example: "A temperature sensor in a thermostat."
  },
  "LED": {
    importance: "A light-emitting diode, which emits light when current flows through it.",
    symbol: "LED",
    example: "An LED used in an indicator light."
  },
  "Relay": {
    importance: "An electrically operated switch.",
    symbol: "RY",
    example: "A relay used to control a high voltage circuit with a low voltage signal."
  },
  "Switch": {
    importance: "A device for making and breaking the connection in an electric circuit.",
    symbol: "SW",
    example: "A toggle switch in a power circuit."
  },
  "Transformer": {
    importance: "A device that transfers electrical energy between two or more circuits through electromagnetic induction.",
    symbol: "T",
    example: "A transformer used in a power supply."
  },
  "Microcontroller": {
    importance: "A compact integrated circuit designed to govern a specific operation in an embedded system.",
    symbol: "MCU",
    example: "An Arduino microcontroller used in a DIY project."
  },
  "Potentiometer": {
    importance: "A three-terminal resistor with a sliding or rotating contact that forms an adjustable voltage divider.",
    symbol: "VR",
    example: "A potentiometer used to adjust the volume in an audio circuit."
  },
  "Battery": {
    importance: "A device consisting of one or more electrochemical cells with external connections for powering electrical devices.",
    symbol: "BAT",
    example: "A 9V battery used to power a handheld device."
  },
  "Capacitor": {
    importance: "A device that stores electrical energy in an electric field.",
    symbol: "C",
    example: "A ceramic capacitor used in a signal filter."
  },
  "Inductor": {
    importance: "A passive electronic component that stores energy in its magnetic field.",
    symbol: "L",
    example: "A coil in an RF circuit."
  }
};

const ElectronicsInfo = () => {
  const [selectedItem, setSelectedItem] = useState('Current');
  const [readAloud, setReadAloud] = useState(false);

  const handleItemChange = (e) => {
    setSelectedItem(e.target.value);
  };

  const handleReadAloud = () => {
    const utterance = new SpeechSynthesisUtterance(
      `The electronic component selected is ${selectedItem}. Its importance is ${electronicsData[selectedItem].importance}. The symbol is ${electronicsData[selectedItem].symbol}. An example is ${electronicsData[selectedItem].example}.`
    );
    speechSynthesis.speak(utterance);
    setReadAloud(true);
  };

  return (
    <div className="electronics-info">
      <h1>Electronics Information</h1>
      <div>
        <label>
          Select Electronic Component:
          <select value={selectedItem} onChange={handleItemChange}>
            {Object.keys(electronicsData).map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="info">
        <h2>{selectedItem}</h2>
        <p><strong>Importance:</strong> {electronicsData[selectedItem].importance}</p>
        <p><strong>Symbol:</strong> {electronicsData[selectedItem].symbol}</p>
        <p><strong>Example:</strong> {electronicsData[selectedItem].example}</p>
      </div>
      <button onClick={handleReadAloud}>Read Aloud</button>
    </div>
  );
};

export default ElectronicsInfo;
